import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPagination } from 'types/pagination.types';
import {
  FormValues,
  ITagsPaginationArgs,
  ModalState,
  TagItem,
  TagsPageState,
} from 'types/tags-page';

const initialState: TagsPageState = {
  getTagsRequestStatus: undefined,
  tags: [],
  pagination: {
    current: -1,
    pageSize: 30,
    total: -1,
  },
  errorMessage: '',
  successMessage: '',
  activeTag: null,
  drawerStatus: ModalState.closed,
  submitting: false,
  deleteModalStatus: ModalState.closed,
};

const tagsSlice = createSlice({
  name: 'tagsPage',
  initialState,
  reducers: {
    getTagsRequest: (state, _: PayloadAction<Partial<ITagsPaginationArgs>>) => {
      state.getTagsRequestStatus = 'pending';
    },
    setTagsRequestError: (state) => {
      state.getTagsRequestStatus = 'error';
    },
    setTags: (state, action: PayloadAction<{ tags: TagItem[]; pagination: IPagination }>) => {
      state.tags = action.payload.tags;
      state.pagination = action.payload.pagination;
      state.getTagsRequestStatus = 'success';
    },
    setErrorMessage: (state, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },
    setSuccessMessage: (state, action: PayloadAction<string>) => {
      state.successMessage = action.payload;
    },
    setActiveTag: (state, action: PayloadAction<TagItem | null>) => {
      state.activeTag = action.payload;
    },
    setModalStatus: (state, action: PayloadAction<ModalState>) => {
      state.drawerStatus = action.payload;
    },
    setSubmitting: (state, action: PayloadAction<boolean>) => {
      state.submitting = action.payload;
    },
    setDeleteModalStatus: (state, action: PayloadAction<ModalState>) => {
      state.deleteModalStatus = action.payload;
    },
    reset: () => {
      return initialState;
    },
    submitForm: (_, __: PayloadAction<FormValues>) => {},
    deleteTag: () => {},
  },
});

export const { actions, name, reducer } = tagsSlice;
export default reducer;
